import LoggingConstants from 'sharedreact/constants/LoggingConstants';
import type LogEntry from 'sharedreact/data/LogEntry';
import AppDispatcher from 'sharedreact/dispatcher/AppDispatcher';

function log (logEntry: LogEntry): void {
  AppDispatcher.dispatch({
    actionType: LoggingConstants.LOG,
    logEntry: logEntry,
    logLevel: 'neverlog'
  });
}

export default {
  log
};
